export const version = "hdnode/5.2.0";
